"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _SwaggerTypes = /*#__PURE__*/ _interop_require_default(require("~/db/sql-mgr/code/routers/xc-ts/SwaggerTypes"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const setAsAnyType = (field, nullable = true)=>{
    const result = field;
    result.nullable = nullable;
    result.type = undefined;
    result.anyOf = [
        {
            type: 'string'
        },
        {
            type: 'number'
        },
        {
            type: 'integer'
        },
        {
            type: 'boolean'
        },
        {
            type: 'object'
        }
    ];
};
// TODO: refactor and avoid duplication
// Helper function to process a single column and return its swagger field definition
async function processColumnToSwaggerField(context, { column, base, sourcesMap, isLookupHelper = false, dbType }, ncMeta = _Noco.default.ncMeta) {
    const field = {
        title: column.title,
        type: 'object',
        virtual: true,
        column
    };
    switch(column.uidt){
        case _nocodbsdk.UITypes.LinkToAnotherRecord:
            {
                const colOpt = await column.getColOptions(context, ncMeta);
                if (colOpt) {
                    if ([
                        _nocodbsdk.RelationTypes.HAS_MANY,
                        _nocodbsdk.RelationTypes.MANY_TO_MANY
                    ].includes(colOpt.type)) {
                        field.type = 'array';
                        field.items = {
                            type: 'object',
                            properties: {
                                id: {
                                    oneOf: [
                                        {
                                            type: 'string'
                                        },
                                        {
                                            type: 'number'
                                        }
                                    ],
                                    description: 'Record identifier for linking'
                                }
                            },
                            required: [
                                'id'
                            ]
                        };
                        field.virtual = false;
                    } else {
                        field.type = [
                            'object',
                            'null'
                        ];
                        field.properties = {
                            id: {
                                oneOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        type: 'number'
                                    }
                                ],
                                description: 'Record identifier for linking'
                            }
                        };
                    }
                }
            }
            break;
        case _nocodbsdk.UITypes.Formula:
            var _column_colOptions_parsed_tree, _column_colOptions;
            // Extract type from parsed tree if available
            if ((_column_colOptions = column.colOptions) == null ? void 0 : (_column_colOptions_parsed_tree = _column_colOptions.parsed_tree) == null ? void 0 : _column_colOptions_parsed_tree.dataType) {
                const formulaDataType = column.colOptions.parsed_tree.dataType;
                switch(formulaDataType){
                    case _nocodbsdk.FormulaDataTypes.NUMERIC:
                        field.type = [
                            'number',
                            'null'
                        ];
                        break;
                    case _nocodbsdk.FormulaDataTypes.STRING:
                        field.type = [
                            'string',
                            'null'
                        ];
                        break;
                    case _nocodbsdk.FormulaDataTypes.DATE:
                        field.type = [
                            'string',
                            'null'
                        ];
                        field.format = 'date-time';
                        break;
                    case _nocodbsdk.FormulaDataTypes.BOOLEAN:
                    case _nocodbsdk.FormulaDataTypes.LOGICAL:
                    case _nocodbsdk.FormulaDataTypes.COND_EXP:
                        field.type = [
                            'boolean',
                            'null'
                        ];
                        break;
                    case _nocodbsdk.FormulaDataTypes.NULL:
                    case _nocodbsdk.FormulaDataTypes.UNKNOWN:
                    default:
                        // Fallback to any if type not handled
                        setAsAnyType(field);
                        break;
                }
            } else {
                // Fallback to any if no parsed tree available
                setAsAnyType(field);
            }
            break;
        case _nocodbsdk.UITypes.Lookup:
            if (isLookupHelper) {
                // For recursive lookup resolution, get the underlying column type
                const colOpt = await column.getColOptions(context, ncMeta);
                if (colOpt) {
                    const lookupCol = await colOpt.getLookupColumn(context);
                    return await processColumnToSwaggerField(context, {
                        column: lookupCol,
                        base,
                        dbType,
                        sourcesMap,
                        isLookupHelper: true
                    }, ncMeta);
                }
                setAsAnyType(field);
            } else {
                // For main lookup processing, determine relation type and structure
                const colOpt = await column.getColOptions(context, ncMeta);
                if (colOpt) {
                    const relationCol = await colOpt.getRelationColumn(context);
                    const relationColOpt = await relationCol.getColOptions(context, ncMeta);
                    const { refContext } = await relationColOpt.getRelContext(context);
                    const lookupCol = await colOpt.getLookupColumn(refContext);
                    const refBase = !relationColOpt.fk_related_base_id || base.id === relationColOpt.fk_related_base_id ? base : await _models.Base.get(refContext, relationColOpt.fk_related_base_id);
                    // Get the type of the lookup column by recursively processing it
                    const lookupField = await processColumnToSwaggerField(refContext, {
                        column: lookupCol,
                        base: refBase,
                        sourcesMap,
                        isLookupHelper: true,
                        dbType
                    }, ncMeta);
                    // Determine if this is a single value or array based on relation type
                    if (relationColOpt && (relationColOpt.type === _nocodbsdk.RelationTypes.BELONGS_TO || relationColOpt.type === _nocodbsdk.RelationTypes.ONE_TO_ONE)) {
                        // Single value lookup
                        field.type = lookupField.type;
                        field.format = lookupField.format;
                        field.$ref = lookupField.$ref;
                        field.items = lookupField.items;
                        field.anyOf = lookupField.anyOf;
                        field.nullable = lookupField.nullable;
                    } else {
                        // Array lookup (HAS_MANY or MANY_TO_MANY)
                        field.type = 'array';
                        if (lookupField.$ref) {
                            field.items = {
                                $ref: lookupField.$ref
                            };
                        } else {
                            field.items = {
                                type: lookupField.type,
                                format: lookupField.format,
                                anyOf: lookupField.anyOf,
                                nullable: lookupField.nullable
                            };
                        }
                    }
                } else {
                    // Fallback to object if we can't determine the type
                    setAsAnyType(field);
                }
            }
            break;
        case _nocodbsdk.UITypes.Rollup:
            {
                const colOptions = await column.getColOptions(context, ncMeta);
                if (![
                    'max',
                    'min'
                ].includes(colOptions.rollup_function.toLowerCase())) {
                    field.type = 'number';
                } else {
                    // if min or max, let it be any
                    setAsAnyType(field);
                }
                break;
            }
        case _nocodbsdk.UITypes.Links:
            field.type = 'integer';
            break;
        case _nocodbsdk.UITypes.Attachment:
            field.type = [
                'array',
                'null'
            ];
            field.items = {
                $ref: `#/components/schemas/Attachment`
            };
            field.virtual = false;
            break;
        case _nocodbsdk.UITypes.MultiSelect:
            field.type = [
                'array',
                'null'
            ];
            field.items = {
                type: 'string'
            };
            field.virtual = false;
            break;
        case _nocodbsdk.UITypes.Email:
            field.type = [
                'string',
                'null'
            ];
            field.format = 'email';
            field.virtual = false;
            break;
        case _nocodbsdk.UITypes.URL:
            field.type = [
                'string',
                'null'
            ];
            field.format = 'uri';
            field.virtual = false;
            break;
        case _nocodbsdk.UITypes.User:
            {
                const userProperties = {
                    id: {
                        type: 'string'
                    },
                    email: {
                        type: 'string'
                    },
                    display_name: {
                        type: [
                            'string',
                            'null'
                        ]
                    }
                };
                field.type = [
                    'array',
                    'null'
                ];
                field.items = {
                    type: 'object',
                    properties: userProperties
                };
                field.virtual = false;
                break;
            }
        case _nocodbsdk.UITypes.LastModifiedTime:
            field.type = [
                'string',
                'null'
            ];
            field.format = 'date-time';
            break;
        case _nocodbsdk.UITypes.CreatedTime:
            field.type = 'string';
            field.format = 'date-time';
            break;
        case _nocodbsdk.UITypes.LastModifiedBy:
            field.type = [
                'object',
                'null'
            ];
            break;
        case _nocodbsdk.UITypes.CreatedBy:
            field.type = 'object';
            break;
        case _nocodbsdk.UITypes.QrCode:
        case _nocodbsdk.UITypes.Barcode:
            // both set to any for now
            // not worth to handle atm
            setAsAnyType(field);
            break;
        default:
            field.virtual = false;
            _SwaggerTypes.default.setSwaggerType('3.1', column, field, dbType);
            break;
    }
    return field;
}
const _default = async (context, { columns, base, sourcesMap }, ncMeta = _Noco.default.ncMeta)=>{
    // Extract dbtype based on column source
    const dbType = await base.getSources().then((sources)=>{
        var _columns_, _sources_find, _sources_;
        const sourceId = (_columns_ = columns[0]) == null ? void 0 : _columns_.source_id;
        return ((_sources_find = sources.find((s)=>s.id === sourceId)) == null ? void 0 : _sources_find.type) || ((_sources_ = sources[0]) == null ? void 0 : _sources_.type);
    });
    return Promise.all(columns.map(async (c)=>{
        return await processColumnToSwaggerField(context, {
            column: c,
            base,
            sourcesMap,
            isLookupHelper: false,
            dbType
        }, ncMeta);
    }));
};
